function mapAttribute(attr: CQA.Attribute): CQA.ResolverAttributeDto {
  return {
    id: attr.id,
    entityId: attr.entityId,
    entityType: attr.entityType,
    questionId: attr.questionId,
    answerSetId: attr.answerSetId,
    answerValueId: attr.answerValueId,
    answerDisplayText: attr.answerDisplayText
  };
}

function mapSpan(span: Accelerate.SpanAnnotation): CQA.ResolverSpanDto {
  return {
    id: span.id,
    beginOffset: span.beginOffset,
    endOffset: span.endOffset,
    coveredText: span.coveredText,
    documentId: span.documentId,
    attributes: (span.rubricAttributes ?? []).map(mapAttribute),
  };
}

/**
 * Build workItemData from the first invoice (which has work item fields merged when loaded).
 */
function mapWorkItemData(firstInvoice: Accelerate.CQAInvoice | undefined): CQA.ResolverWorkItemDto | undefined {
  if (!firstInvoice) return undefined;
  return {
    id: (firstInvoice as { workitemId?: number }).workitemId ?? (firstInvoice as { id?: number }).id,
    caseId: (firstInvoice as { sdCaseId?: string }).sdCaseId ?? (firstInvoice as { caseId?: string }).caseId,
    caseJsonId: (firstInvoice as { caseJsonId?: string }).caseJsonId,
    tenantUid: (firstInvoice as { tenantUid?: string }).tenantUid,
    processInstanceGuid: (firstInvoice as { processInstanceGuid?: string | null }).processInstanceGuid,
    caseRunUid: (firstInvoice as { caseRunUid?: string }).caseRunUid,
    serviceLine: (firstInvoice as { serviceLine?: string }).serviceLine,
    healthSystemTenantId: (firstInvoice as { healthSystemTenantId?: string }).healthSystemTenantId,
    status: (firstInvoice as { status?: string }).status,
    importId: (firstInvoice as { importId?: string }).importId,
    ruleId: (firstInvoice as { ruleId?: string }).ruleId,
    ruleName: (firstInvoice as { ruleName?: string }).ruleName,
    ruleCollectionId: (firstInvoice as { ruleCollectionId?: string }).ruleCollectionId
  };
}

const mapCode = (codeType: CQA.ResolverCodeType, code: Accelerate.CQAProcedure | Accelerate.CQADiagnosis | Accelerate.CQAModifier): CQA.ResolverCodeDto => {
  return {
    codeType: codeType,
    id: code.id,
    code: code.code,
    original: code.original,
    sequenceNumber: code.sequenceNumber ?? 0,
    attributes: (code.attributes ?? []).map(mapAttribute),
    spans: (code.spans ?? []).map(mapSpan)
  };
}


/**
 * Maps grade-bench panel state to ResolverInputDto for POST /resolver/resolve.
 */
export function gradeBenchStateToResolverInput(
  state: Accelerate.GradeBenchPanelState
): CQA.ResolverInputDto {
  const codes: CQA.ResolverCodeDto[] = [];
  const invoices = state.invoices ?? [];

  invoices.forEach((invoice, invIdx) => {
    (invoice.transactions ?? []).forEach((tx, txIdx) => {
      
      (tx.procedures ?? []).forEach((p) =>
        codes.push(mapCode('PROCEDURE', p))
      );
      (tx.diagnoses ?? []).forEach((d) =>
        codes.push(mapCode('DIAGNOSIS', d))
      );
      (tx.modifiers ?? []).forEach((m) =>
        codes.push(mapCode('MODIFIER', m))
      );
    });
  });

  
  const caseAttributes = (state.caseAttributes ?? []).map(mapAttribute);
  const workItemData = mapWorkItemData(invoices[0]);
  const looseSpans = (state.looseSpans ?? []).map(mapSpan);

  return {
    codes,
    caseAttributes,
    workItemData,
    looseSpans
  };
}
